var map = {
	selectors: {
		mapView: '.sellers-map__view',
    },
    icons: {
        info: '<svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.80767 8.93656L4.68001 9.45843C4.29702 9.60959 3.9911 9.72464 3.76329 9.80374C3.53523 9.88309 3.27025 9.92256 2.96833 9.92256C2.50469 9.92256 2.14406 9.80898 1.88685 9.58339C1.62965 9.35689 1.501 9.06988 1.501 8.72169C1.501 8.58691 1.51034 8.44827 1.52974 8.30702C1.54932 8.1656 1.58043 8.00633 1.62301 7.82831L2.10164 6.13424C2.14422 5.97202 2.18042 5.81832 2.2094 5.67297C2.2388 5.52852 2.25297 5.39562 2.25297 5.27598C2.25297 5.05964 2.20818 4.90831 2.119 4.82323C2.02983 4.7384 1.85967 4.69532 1.60705 4.69532C1.48332 4.69532 1.35614 4.71514 1.22652 4.75346C1.09632 4.79195 0.985034 4.82913 0.891602 4.86368L1.01959 4.34141C1.33313 4.21375 1.63284 4.10443 1.91953 4.0137C2.20621 3.92272 2.47709 3.87719 2.73332 3.87719C3.19377 3.87719 3.54907 3.98848 3.79858 4.21105C4.04809 4.43378 4.1728 4.72251 4.1728 5.07831C4.1728 5.15192 4.16461 5.28163 4.14701 5.46702C4.12981 5.65283 4.09779 5.82307 4.05112 5.97792L3.57454 7.66519C3.53548 7.80071 3.50035 7.95564 3.46981 8.12998C3.43828 8.30317 3.42321 8.4355 3.42321 8.52426C3.42321 8.74831 3.47316 8.90127 3.57331 8.98258C3.67419 9.0639 3.84796 9.10435 4.09476 9.10435C4.21063 9.10435 4.34247 9.0838 4.48897 9.04343C4.63505 9.00306 4.74159 8.9676 4.80767 8.93656ZM4.92854 1.85287C4.92854 2.14685 4.81774 2.39791 4.59509 2.60435C4.37302 2.81152 4.10541 2.91519 3.79236 2.91519C3.47832 2.91519 3.21006 2.81152 2.98545 2.60435C2.76124 2.39783 2.64889 2.14685 2.64889 1.85287C2.64889 1.55947 2.76124 1.308 2.98545 1.09894C3.20965 0.890212 3.4784 0.785889 3.79236 0.785889C4.10533 0.785889 4.37302 0.890458 4.59509 1.09894C4.81791 1.308 4.92854 1.55955 4.92854 1.85287Z" fill="white"/></svg>'
    },
	init: function () {
		var self = this;

		if (document.querySelector(self.selectors.mapView)) {
            self.initiateMap();
		}
    },
    initiateMap: function () {
        var self = this;

        var $map = document.querySelector(self.selectors.mapView);
        // console.log( mapboxData );

        if (mapboxData['map'] && $map) {
            var mapData = mapboxData['map'];

            mapboxgl.accessToken = mapboxData.accessToken;
            var map = new mapboxgl.Map({
                container: $map,
                style: mapData.style,
                center: [mapData.center_lng, mapData.center_lat],
                zoom: mapData.zoom,
            });

            map.scrollZoom.disable();

            map.addControl(new mapboxgl.NavigationControl(), 'top-left');
            map.addControl(new mapboxgl.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            }));

            if (mapData['markers']) {
                //var $markerLegends = $map.parent().find('[data-map-marker]');
                var markers = mapData['markers'];
                // var markerObjects = [];

                var i = 0;
                var bounds = new mapboxgl.LngLatBounds();

                for (var marker in markers) {
                    // console.log( markers[marker] );

                    var markerData = markers[marker],
                    markerEl = document.createElement('a');
                    // markerEl.className = 'map__marker';
                    markerEl.setAttribute('class', 'map__marker ' + markerData.filters_list );
                    markerEl.setAttribute('data-map-target', i);
                    markerEl.setAttribute('postid', markerData.post_id );
                    markerEl.setAttribute('data-modal-trigger', 'marker' );
                    markerEl.setAttribute('data-map-coordinates', JSON.stringify([markerData.lng, markerData.lat]));

                    if (i === 0) {
                        // markerEl.className = 'map__marker active';
                    }

                    markerEl.innerHTML = '<i class="mapbox-icon">'+ self.icons.info +'</i>';

                    var markerObject = new mapboxgl.Marker(markerEl).setLngLat([markerData.lng, markerData.lat]).addTo(map);

                    bounds.extend([markerData.lng, markerData.lat]);

                    i++;
                }


                jQuery('.map__marker').on('click', function (e) {
                    // e.stopPropagation();

                    var $marker = $(this);

                    $marker.addClass('active');
                    var post_id = $marker.attr( 'postid' );
                    var coordinates = JSON.parse( $marker.attr('data-map-coordinates') );

                    self.getMarkerInfo( post_id );

                    map.flyTo({
                        center: coordinates,
                    });
                });

                /* $markerLegends.on('click', function (e) {
                    var target = $(this).attr('data-map-marker');
                    var $marker = markers.filter('[data-map-target="' + target + '"]');

                    $marker.trigger('click');
                }); */

                //map.fitBounds(bounds, { padding: 100 });
            }
        }
    },
    getMarkerInfo: function( post_id ) {
        var data = {
            'action': 'load_marker_info',
            'post_id': post_id,
        };
 
        jQuery.post(themeVars.ajax_url, data, function(response) {
            jQuery('.modal__inner--marker').html( response );
        });
    },
};

export { map };
